import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"

function Footer() {
  const data = useStaticQuery(graphql`
    query {
      logo_pc: file(relativePath: { eq: "pc_footer_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logo_sp: file(relativePath: { eq: "sp_footer_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logo_pc: file(relativePath: { eq: "pc_footer_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      footer_line: file(relativePath: { eq: "footer_line.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      footer_instagram: file(relativePath: { eq: "footer_instagram.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Box bgcolor="#E5E5E5">
        <Hidden xsDown>
          <Box pt={6} pb={10}>
            <Box width="88%" maxWidth="1273px" m="auto" mb={6}>
              <Box width="179.18px">
                <Img fluid={data.logo_pc.childImageSharp.fluid} />
              </Box>
            </Box>

            <Box width="88%" maxWidth="1273px" m="auto">
              <Grid item xs={12} sm={10} md={8} lg={6}>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="flex-start"
                >
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      justify="space-around"
                      alignItems="flex-start"
                    >
                      <Box mb={1}>
                        <Grid item xs={12}>
                          <Link to={"/product"}>
                            <WrapTypo
                              isHunter={true}
                              fs="14px"
                              xsfs=""
                              mdfs="14px"
                              ld="14px"
                            >
                              PRODUCT
                            </WrapTypo>
                          </Link>
                        </Grid>
                      </Box>
                      <Box mb={1}>
                        <Grid item xs={12}>
                          <Link to={"https://unfilter.co.jp/shop/customer"}>
                            <WrapTypo
                              isHunter={true}
                              fs="14px"
                              xsfs=""
                              mdfs="14px"
                              ld="14px"
                            >
                              LOGIN
                            </WrapTypo>
                          </Link>
                        </Grid>
                      </Box>

                      <Box mb={1}>
                        <Grid item xs={12}>
                          <Link to={"/faq"}>
                            <WrapTypo
                              isHunter={true}
                              fs="14px"
                              xsfs=""
                              mdfs="14px"
                              ld="14px"
                            >
                              FAQ
                            </WrapTypo>
                          </Link>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <WrapTypo
                      isHunter={true}
                      fs="14px"
                      xsfs=""
                      mdfs="14px"
                      ld="14px"
                    >
                      FOLLOW US
                    </WrapTypo>
                    <Grid container direction="row" alignItems="center">
                      <Link to={"https://lin.ee/vNCiMwP"}>
                        <Box width="29px" mr={2}>
                          <Img fluid={data.footer_line.childImageSharp.fluid} />
                        </Box>
                      </Link>
                      <Link
                        to={
                          "https://instagram.com/unfilter_official?igshid=1v8i9bx1ok826"
                        }
                      >
                        <Box width="29px">
                          <Img
                            fluid={data.footer_instagram.childImageSharp.fluid}
                          />
                        </Box>
                      </Link>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <WrapTypo
                      isHunter={true}
                      fs="14px"
                      xsfs=""
                      mdfs="14px"
                      ld="14px"
                    >
                      INFORMATION
                    </WrapTypo>
                    <WrapTypo fs="12px">〒150-0001</WrapTypo>
                    <WrapTypo fs="12px">東京都渋谷区神宮前6-17-15</WrapTypo>
                    <WrapTypo fs="12px">落合原宿ビル3F</WrapTypo>
                  </Grid>
                  <Grid item>
                    <Link to={"https://unfilter.co.jp/shop/pages/henkin"}>
                      <WrapTypo fs="14px" xsfs="" mdfs="14px" ld="14px">
                        返金保証について
                      </WrapTypo>
                    </Link>
                    <Link to={"https://unfilter.co.jp/lp?u=trade_law"}>
                      <WrapTypo fs="14px" xsfs="" mdfs="14px" ld="14px">
                        特定商取引法
                      </WrapTypo>
                    </Link>
                    <Link
                      target={"_blank"}
                      rel="noopener noreferrer"
                      to={"https://unfilter.co.jp/lp?u=privacypolicy"}
                    >
                      <WrapTypo fs="14px" xsfs="" mdfs="14px" ld="14px">
                        プライバシーポリシー
                      </WrapTypo>
                    </Link>
                    <Link to={"https://unfilter.co.jp/shop/base_info"}>
                      <WrapTypo fs="14px" xsfs="" mdfs="14px" ld="14px">
                        会社概要
                      </WrapTypo>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Hidden>

        {/* sp_footer */}
        <Hidden smUp>
          <Box width="78%" pt={6} pb={6} m="auto">
            <Box mb={5}>
              <Box width="107.32px" height="18.21px">
                <Img fluid={data.logo_sp.childImageSharp.fluid} />
              </Box>
            </Box>
            <Box>
              <Grid
                container
                direction="column"
                justify="space-between"
                alignItems="flex-start"
                style={{ minHeight: "260px" }}
              >
                <Grid item>
                  <Link to={"/product"}>
                    <WrapTypo isHunter={true} fs="18px">
                      PRODUCT
                    </WrapTypo>
                  </Link>
                </Grid>

                <Grid item>
                  <Link to={"https://unfilter.co.jp/shop/customer"}>
                    <WrapTypo isHunter={true} fs="18px">
                      LOGIN
                    </WrapTypo>
                  </Link>
                </Grid>
                <Grid item>
                  <Link to={"/faq"}>
                    <WrapTypo isHunter={true} fs="20px">
                      FAQ
                    </WrapTypo>
                  </Link>
                </Grid>
                <Grid item>
                  <WrapTypo isHunter={true} fs="20px">
                    FOLLOW US
                  </WrapTypo>
                  <Grid container direction="row">
                    <Link
                      to={
                        "https://instagram.com/unfilter_official?igshid=1v8i9bx1ok826"
                      }
                    >
                      <Box width="23px" mr={2}>
                        <Img
                          fluid={data.footer_instagram.childImageSharp.fluid}
                        />
                      </Box>
                    </Link>
                    <Link to={"https://lin.ee/vNCiMwP"}>
                      <Box width="23px">
                        <Img fluid={data.footer_line.childImageSharp.fluid} />
                      </Box>
                    </Link>
                  </Grid>
                </Grid>
                <Grid item>
                  <Box mt="8px">
                    <Link to={"https://unfilter.co.jp/shop/pages/henkin"}>
                      <WrapTypo fs="16px">返金保証について</WrapTypo>
                    </Link>
                    <Link to={"https://unfilter.co.jp/lp?u=trade_law"}>
                      <WrapTypo fs="16px">特定商取引法</WrapTypo>
                    </Link>
                    <Link
                      target={"_blank"}
                      rel="noopener noreferrer"
                      to={"https://unfilter.co.jp/lp?u=privacypolicy"}
                    >
                      <WrapTypo fs="16px">プライバシーポリシー</WrapTypo>
                    </Link>
                    <Link to={"https://unfilter.co.jp/shop/base_info"}>
                      <WrapTypo fs="16px">会社概要</WrapTypo>
                    </Link>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Hidden>
        {/* sp_footer */}
      </Box>
    </>
  )
}

export default Footer
